<template>
  <div class="app-form frame-page basic-form-vue empresas-window">
    <ModalPrimeiroAcesso @clearfirstAccess="clearfirstAccess" :firstAccess="firstAccess" v-if="firstAccess" />
    <ModalEmpresas />
    <ModalVd />
    <div class="h-panel main-container">
      <div class="h-panel-bar">
        <span class="h-panel-title">Empresas</span>
      </div>
      <div class="h-panel-body empresas-filtro">
        <div class="h-panel h-panel-filtro">
          <Collapse v-model="filterCollapse" accordion>
            <CollapseItem>
                <template slot='title'>
                  <div class="h-panel-bar">
                    <span class="h-panel-title">Filtro</span>
                    <span class="h-panel-right">
                      <Button style="margin-right: -6px;" :icon-circle='true' :circle="true" :icon="iconCollapse"
                      ></Button>
                    </span>
                  </div>
                </template>
                <div class="h-panel-body">
                <Row :space="10" v-if="!permissionConfig">
                    <div class="h-row">
                      <Cell :xs='24' :sm='12' :md='12' :lg='12' :xl='12'>
                        <label>Nome:</label>
                        <div class="h-input h-input-prefix-icon inputs-filtro">
                          <input @keyup="handleSearch" type="text" v-model="searchParm" placeholder="Filtrar Empresa pelo nome"/>
                          <i class="h-icon-search"></i>
                        </div>
                      </Cell>
                      <Cell :xs='24' :sm='12' :md='12' :lg='12' :xl='12' class="filter-options" >
                        <div class="checkboxContainer">
                          <Checkbox  v-model="isVarejo">
                            <label>  Varejo</label>
                          </Checkbox>
                            <Checkbox  v-model="isVd">
                            <label>  Venda Direta</label>
                          </Checkbox>
                        </div>
                      </Cell>
                    </div>
                </Row>
                </div>
            </CollapseItem>
          </Collapse>
        </div>
        </div>
         <TableEmpresas v-if="!permissionConfig" />
    </div>
  </div>
</template>
<script>
import { ScreenSize } from '../../mixins/ModalSize';
import TableEmpresas from './tableEmpresas.vue';
import ModalEmpresas from './modalEmpresas.vue';
import ModalVd from './modalEstruturaVenda.vue';
import ModalPrimeiroAcesso from './modalPrimeiroAcesso.vue';
import { regras } from '../../../js/config/permissions';

import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('empresas');
export default {
  components: {
    TableEmpresas,
    ModalEmpresas,
    ModalVd,
    ModalPrimeiroAcesso
  },
  mixins: [ScreenSize],
  data() {
    return {
      filterCollapse: [0],
      searchParm: '',
      initialValue: [],
      isVarejo: true,
      isVd: true,
      firstAccess: false
    };
  },
  computed: {
    ...mapState({
      empresas: state => state.empresas
    }),
    iconCollapse() {
      return 'h-icon-' + (this.filterCollapse.length ? 'minus' : 'plus');
    },
    permissionConfig() {
      const permissaoRegras = Utils.getPermission(regras.regras);
      return !permissaoRegras;
    }
  },
  methods: {
    ...mapMutations(['handleFilterByOperation', 'setEmpresas', 'setSource']),
    ...mapActions(['getEmpresas']),
    handleFilterOperation(type) {
      this.handleFilterByOperation(type);
    },
    async handleSearch() {
      if (!this.searchParm) await this.getEmpresas();
      else {
        const regex = new RegExp(`${this.searchParm}`, 'mi');
        const searchResult = this.initialValue.filter(e => regex.test(e.nome));
        this.setEmpresas(searchResult);
      }
    },
    clearfirstAccess() {
      this.firstAccess = false;
    }
  },
  created() {
    Utils.trackingF360(this, 'Listar', 'Gerenciar - Empresas');
  },
  async mounted() {
    await this.getEmpresas();
    this.initialValue = JSON.parse(JSON.stringify(this.empresas));
    this.setSource('tela-empresas');
    if (this.empresas) {
      const IsUnset = this.empresas.find(e => e.isResale || e.isRetail);
      this.firstAccess = !(IsUnset);
    }
  },
  beforeDestroy() {
    this.setSource('');
  },
  watch: {
    async isVd(value) {
      await this.getEmpresas();
      if (!value) {
        this.handleFilterOperation('VD');
      }
      if (!this.isVarejo) {
        this.handleFilterOperation('Varejo');
      }
    },
    async isVarejo(value) {
      await this.getEmpresas();
      if (!value) {
        this.handleFilterOperation('Varejo');
      }
      if (!this.isVd) {
        this.handleFilterOperation('VD');
      }
    }
  }
};
</script>
<style lang="less">
.inputs-filtro {
  width: 100%;
}
.main-container{
padding:4px
}

.h-panel-body.empresas-filtro .h-panel-bar {
  padding: 0px 12px;
}

.empresas-filtro .h-panel {
  border: 1px solid #eee;
}
.h-panel-body.empresas-filtro .h-collapse-item-expand {
  position: absolute;
  display: none;
}
.empresas-window .h-table th {
  padding: 5px 0 5px 16px;
  height: 35px;
}
.empresas-window .h-table td {
  height: 40px;
}

.checkboxContainer{
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 24px;
}
</style>
